///var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/EventDialog.js

import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { openDB } from 'idb';
import { Dialog, Button, Card, Toast, Chip } from 'primereact';
import { useSelector } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUserGroup, faPeopleGroup, faSpa, faGift, faCrown } from '@fortawesome/free-solid-svg-icons';
import styles_ed from '../css/EventDialog.module.scss';
import styles from '../css/OverlayPanel.module.scss';
import '../css/SwitchEventDialog.scss';
import EventDialogServiceTimeSidebarAll from './DataQueues/EventDialogServiceTimeSidebarAll.js';
import CustomerSearch from '../components/EventDialog/CustomerSearch';
import DateOfService from '../components/EventDialog/DateOfService';
import EmployeeSelect from '../components/EventDialog/EmployeeSelect';
import ServiceTypeSidebar from '../components/EventDialog/ServiceTypeSidebar.js';
import { languageManager } from '../utils/loadLanguage';
import { API_URLS, getSelectedLanguage } from '../api/api';

const initDB = async () => {
  return await openDB('SelectionsDB', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('selections')) {
        db.createObjectStore('selections', { keyPath: 'id' });
      }
    }
  });
};

const EventDialog = ({ show, onHide }) => {
  const userID = localStorage.getItem('user_ID');
  const selectedEmployee = useSelector((state) => state.employee.selectedEmployee);

  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState({});
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectedDateEvent, setSelectedDateEvent] = useState('');
  const [selectedPriceFor, setSelectedPriceFor] = useState('');
  const [priceData, setPriceData] = useState([]);
  const [cumulativePrice, setCumulativePrice] = useState(0);
  const [priceSelections, setPriceSelections] = useState({});
  const [selectedService, setSelectedService] = useState(null);
  const [selectedPriceID, setSelectedPriceID] = useState(null);
  const [selectedServiceTimesCount, setSelectedServiceTimesCount] = useState(0);
  const [reserveServiceTimes, setReserveServiceTimes] = useState([]);
  const [amountPaid, setAmountPaid] = useState(0);
  const [isEmployeeSelected, setIsEmployeeSelected] = useState(false);

  const toast = useRef(null);
  const [translations, setTranslations] = useState({});
  const firstRender = useRef(true);
  const [topSidebarVisible, setTopSidebarVisible] = useState(false);

  const [refreshServiceTimes, setRefreshServiceTimes] = useState(() => () => {});

  useEffect(() => {
    fetchServiceOptions();
    loadSelectionsFromDB();
    setSelectedDateEvent(new Date().toISOString().slice(0, 10));

    async function loadLang() {
      const lang = getSelectedLanguage();
      await languageManager.loadLanguage(lang);
      setTranslations(languageManager.translations);
    }
    loadLang();
  }, []);

  const updateAmountPaid = (amount) => {
    setAmountPaid(amount);
  };

  const showToast = (severity, summary, detail) => {
    if (toast.current) {
      toast.current.show({ severity, summary, detail, life: 3000 });
    }
  };

  /** Fetch Service Options */
  const fetchServiceOptions = async () => {
    try {
      const response = await axios.get(API_URLS.SERVICES);
      if (response.data && Array.isArray(response.data)) {
        const options = response.data.map((item) => ({
          label: `${item.ServiceName} - ${item.ServiceTypes_Name}`,
          value: item.ServiceID
        }));
        setSelectOptions(options);
      }
    } catch (error) {
      console.error('Error fetching service options:', error);
    }
  };

  /** Fetch Price Data */
  const fetchPriceData = async (selectedValue) => {
    try {
      const apiParams = {
        status: 1,
        TableData_ID: 3,
        priceConn_dataID: selectedValue,
        PriceFor: selectedPriceFor
      };
      const response = await axios.get(API_URLS.PRICE, { params: apiParams });
      setPriceData(response.data.prices || []);
      const initSelections = (response.data.prices || []).reduce((acc, item) => {
        acc[item.PriceID] = false;
        return acc;
      }, {});
      setPriceSelections(initSelections);
    } catch (error) {
      console.error('Error fetching price data:', error);
    }
  };

  /** Load selections from IndexedDB */
  const loadSelectionsFromDB = async () => {
    const db = await initDB();
    const tx = db.transaction('selections', 'readonly');
    const store = tx.objectStore('selections');
    const allSelections = await store.getAll();
    const newSelections = allSelections.reduce((acc, item) => {
      acc[item.id] = item.selected;
      return acc;
    }, {});
    setPriceSelections(newSelections);
  };

  /** Save selection to IndexedDB */
  const saveSelectionToDB = async (priceID, isSelected) => {
    const db = await initDB();
    const tx = db.transaction('selections', 'readwrite');
    const store = tx.objectStore('selections');
    await store.put({ id: priceID, selected: isSelected });
    await tx.done;
  };

  /** InputSwitch change */
  const handleInputSwitchChange = (priceID, priceValue) => {
    setPriceSelections((prev) => {
      const newState = { ...prev, [priceID]: !prev[priceID] };
      const priceAdjustment = newState[priceID] ? priceValue : -priceValue;
      setCumulativePrice((old) => Math.max(0, old + priceAdjustment));
      setSelectedPriceID(priceID);
      setSelectedServiceTimesCount((old) => old + (newState[priceID] ? 1 : -1));

      if (newState[priceID]) {
        fetchReserveServiceTimes(selectedDateEvent, priceID, setReserveServiceTimes, selectedEmployee);
      }

      sessionStorage.setItem('tempPriceSelections', JSON.stringify(newState));
      sessionStorage.setItem('tempCumulativePrice', JSON.stringify(cumulativePrice + priceAdjustment));
      saveSelectionToDB(priceID, newState[priceID]);

      setTopSidebarVisible(true);
      firstRender.current = true;
      refreshServiceTimes();
      return newState;
    });
  };

  /** Handle select service option */
  const handleSelectOptionChange = (e) => {
    if (!selectedUser.user_ID) {
      showToast('error', 'Error', 'Please select a customer.');
      return;
    }
    if (!selectedDateEvent) {
      showToast('error', 'Error', 'Please select a date of service.');
      return;
    }
    if (!selectedEmployee) {
      showToast('error', 'Error', 'Please select an employee.');
      return;
    }
    if (!selectedPriceFor) {
      showToast('error', 'Error', 'Please select Solo or Duo.');
      return;
    }
    setSelectedService(e.value);
    fetchPriceData(e.value);
    setSidebarVisible(true);
  };

  /** Handle priceFor select */
  const handlePriceForSelect = (value) => {
    if (!selectedUser.user_ID) {
      showToast('error', 'Error', 'Please select a customer.');
      return;
    }
    if (!selectedDateEvent) {
      showToast('error', 'Error', 'Please select a date of service.');
      return;
    }
    if (!selectedEmployee) {
      showToast('error', 'Error', 'Please select an employee.');
      return;
    }
    setSelectedPriceFor(value);
    fetchServiceOptions();
  };

  /** Bypass availability check */
  const checkAvailability = async () => {
    try {
      return true;
    } catch {
      return true;
    }
  };

  /** Submit booking => handleSubmit */
  const handleSubmit = async (paymentAmount, selectedTime, serviceTimeFrom, serviceTimeTo) => {
    const isAvailable = await checkAvailability();
    if (!isAvailable) return;

    const token = localStorage.getItem('token');
    const paymentStatus = paymentAmount === cumulativePrice ? 5 : 4;

    const bookingData = {
      CustomerID: selectedUser.user_ID || searchTerm,
      TotalAmount: cumulativePrice,
      AmountPaid: paymentAmount || 0,
      BookingStatus: 5,
      PaymentStatus: paymentStatus,
      date: selectedDateEvent,
      time: selectedTime // ลบ fallback เพื่อให้ใช้ selectedTime เท่านั้น
    };

    try {
      const response = await fetch(API_URLS.CREATE_BOOKING, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(bookingData)
      });
      if (!response.ok) {
        throw new Error('Failed to create booking');
      }

      const bookingResponse = await response.json();
      if (bookingResponse.Bookings && bookingResponse.Bookings.length > 0) {
        const bookingID = bookingResponse.Bookings[0].BookingID;
        await transformSelectedBookingsForSubmission(bookingID, selectedTime);
      } else {
        console.error('No booking details found');
      }
    } catch (error) {
      console.error('Error submitting booking:', error);
      showToast('error', 'Error', 'There was an error creating the booking.');
    }
  };

  /** สร้าง booking detail */
  const transformSelectedBookingsForSubmission = async (bookingID, selectedTime) => {
    try {
      const selectedIDs = Object.keys(priceSelections).filter((k) => priceSelections[k]);
      for (let pid of selectedIDs) {
        await submitTransformedBookingDetail(bookingID, pid, selectedTime); // ลบ fallback '00:00'
      }
      showToast('success', 'Success', 'Booking details created successfully.');
      resetForm();
    } catch (err) {
      console.error('Error transforming details:', err);
      showToast('error', 'Error', 'There was an error creating the booking details.');
    }
  };

  const submitTransformedBookingDetail = async (bookingID, priceID, detailTime) => {
    const body = [
      {
        BookingID: bookingID,
        ServiceID: priceID,
        EmployeeID: selectedEmployee,
        ServiceDate: selectedDateEvent,
        ServiceTime: detailTime, // ใช้ detailTime โดยตรง
        ServiceStatus: 1,
        TransactionID: 0,
        GiftRecipientID: 0,
        note: 'Special instructions here',
        promotion_id: 0,
        BookingDetailPrice: 0
      }
    ];
    const resp = await fetch(API_URLS.DETAIL_CREATE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!resp.ok) {
      throw new Error('Failed to create booking detail');
    }
  };

  const resetForm = () => {
    setSelectedUser({});
    setSearchTerm('');
    setSelectedDateEvent(new Date().toISOString().slice(0, 10));
    setSelectedPriceFor('');
    setPriceData([]);
    setCumulativePrice(0);
    setPriceSelections({});
    setSelectedService(null);
    setSelectedPriceID(null);
    setSelectedServiceTimesCount(0);
    setReserveServiceTimes([]);
    if (isEmployeeSelected) {
      setIsEmployeeSelected(false);
    }
  };

  /** API fetchReserveServiceTimes */
  const fetchReserveServiceTimes = async (date, priceID, setReserveFn, employeeID) => {
    try {
      if (!employeeID) {
        employeeID = localStorage.getItem('EventselectedEmployee');
      }
      const requestData = {
        date_from: date,
        date_to: date,
        EmployeeID: employeeID
      };
      const response = await axios.get(API_URLS.AVAILABLE_TIMES, {
        params: requestData
      });
      const slots = createReserveServiceTimes(response.data, date);
      if (setReserveFn) setReserveFn(slots);
      sessionStorage.setItem('reserveServiceTimes', JSON.stringify(slots));
    } catch (error) {
      console.error('Failed to fetch time slots:', error);
      const emptySlots = createReserveServiceTimes({}, date);
      if (setReserveFn) setReserveFn(emptySlots);
      sessionStorage.setItem('reserveServiceTimes', JSON.stringify(emptySlots));
    }
  };

  const createReserveServiceTimes = (apiData, date) => {
    const slots = [];
    const availableTimes = apiData[date] || [];
    for (let hour = 0; hour <= 23; hour++) {
      const hourSlot = `${String(hour).padStart(2, '0')}:00`;
      const halfHourSlot = `${String(hour).padStart(2, '0')}:30`;
      const isHourAvailable = availableTimes.some(
        (timeSlot) => timeSlot.time === hourSlot && timeSlot.status === 'available'
      );
      const isHalfHourAvailable = availableTimes.some(
        (timeSlot) => timeSlot.time === halfHourSlot && timeSlot.status === 'available'
      );
      slots.push({ time: hourSlot, statusHH: isHourAvailable ? 'Available' : 'Unavailable' });
      if (hour < 24) {
        slots.push({
          time: halfHourSlot,
          statusHH: isHalfHourAvailable ? 'Available' : 'Unavailable'
        });
      }
    }
    return slots;
  };

  const fetchReserveServiceTimesWithEmployee = (employeeID) => {
    if (employeeID) {
      fetchReserveServiceTimes(selectedDateEvent, selectedPriceID, setReserveServiceTimes, employeeID);
    }
  };

  const toggleTopSidebarVisible = () => {
    setTopSidebarVisible((p) => !p);
  };

  const formattedCumulativePrice = cumulativePrice.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return (
    <>
      <Toast ref={toast} />
      <ServiceTypeSidebar
        visible={sidebarVisible}
        onHide={() => setSidebarVisible(false)}
        toggleTopSidebarVisible={toggleTopSidebarVisible}
        priceData={
          selectedPriceFor === 'Solo'
            ? priceData.filter((item) => item.PriceFor === 'Solo' || item.PriceFor === 'Unknown')
            : selectedPriceFor === 'Duo'
            ? priceData.filter((item) => item.PriceFor === 'Duo' || item.PriceFor === 'Unknown')
            : priceData
        }
        priceSelections={priceSelections}
        handleInputSwitchChange={handleInputSwitchChange}
        clearCumulativePrice={() => setCumulativePrice(0)}
        maxServiceTimes={selectedServiceTimesCount}
        resetFirstRender={() => {
          firstRender.current = true;
        }}
        refreshServiceTimes={refreshServiceTimes}
      />
      <EventDialogServiceTimeSidebarAll
        isSidebarVisible={topSidebarVisible}
        onHide={toggleTopSidebarVisible}
        toggleTopSidebarVisible={toggleTopSidebarVisible}
        hideServiceTypeSidebar={() => setSidebarVisible(false)}
        selectedDate={selectedDateEvent}
        maxServiceTimes={selectedServiceTimesCount}
        showToast={showToast}
        priceID={selectedPriceID}
        fetchReserveServiceTimes={fetchReserveServiceTimes}
        setReserveServiceTimes={setReserveServiceTimes}
        cumulativePrice={cumulativePrice}
        handleSubmit={handleSubmit}
        onHideDialog={onHide}
        clearCumulativePrice={() => setCumulativePrice(0)}
        updateAmountPaid={updateAmountPaid}
        selectedEmployee={selectedEmployee}
        setRefreshServiceTimes={setRefreshServiceTimes}
      />
      <Dialog
        visible={show}
        className={styles_ed.customDialog}
        header={translations.dialog?.header || 'POINT OF SALE SYSTEM | WEB APPLICATION'}
        modal
        onHide={onHide}
      >
        <Container className={styles_ed.dialogContainer}>
          <Card className={`${styles_ed.bgindex2}`}>
            <Row className='justify-content-md-center mt-2'>
              <Col xs={12} md={12}>
                <Chip
                  label={`${translations.user?.firstName || 'First Name'}: ${selectedUser.first_name || ''}`}
                  className={`ms-2 ${styles_ed.chipindex1}`}
                />
                <Chip
                  label={`${translations.user?.lastName || 'Last Name'}: ${selectedUser.sur_name || ''}`}
                  className={`ms-2 ${styles_ed.chipindex1}`}
                />
                <Chip
                  label={`${translations.user?.phone || 'Phone'}: ${selectedUser.telephone || ''}`}
                  className={`ms-2 ${styles_ed.chipindex1}`}
                />
                <Chip
                  label={`${translations.user?.email || 'Email'}: ${selectedUser.email || ''}`}
                  className={`ms-2 ${styles_ed.chipindex1}`}
                />
              </Col>
            </Row>
            <Row className='justify-content-md-center mt-4'>
              <Col xs={12} md={12} className={styles.searchSection}>
                <Row>
                  <Col xs={4}>
                    <CustomerSearch userID={userID} onUserSelect={setSelectedUser} />
                  </Col>
                  <Col xs={4}>
                    <DateOfService
                      selectedDateEvent={selectedDateEvent}
                      setSelectedDateEvent={setSelectedDateEvent}
                    />
                  </Col>
                  <Col xs={4}>
                    <EmployeeSelect
                      userID={userID}
                      selectedEmployee={selectedEmployee}
                      setIsEmployeeSelected={setIsEmployeeSelected}
                      fetchReserveServiceTimes={fetchReserveServiceTimesWithEmployee}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
          <Row className='mt-5'>
            <Col xs={12} md={6}>
              <Row className='gx-2'>
                <Col xs={4} md={4} className='d-flex justify-content-center'>
                  <Button
                    label={translations.service?.solo || 'Solo'}
                    className={`${styles_ed.bigButton} ${
                      selectedPriceFor === 'Solo' ? styles_ed.selectedButton : ''
                    } ${styles_ed.bgindex1}`}
                    icon={<FontAwesomeIcon icon={faUser} />}
                    onClick={() => handlePriceForSelect('Solo')}
                    iconPos='left'
                  />
                </Col>
                <Col xs={4} md={4} className='d-flex justify-content-center'>
                  <Button
                    label={translations.service?.duo || 'Duo'}
                    className={`${styles_ed.bigButton} ${
                      selectedPriceFor === 'Duo' ? styles_ed.selectedButton : ''
                    } ${styles_ed.bgindex1}`}
                    icon={<FontAwesomeIcon icon={faUserGroup} />}
                    onClick={() => handlePriceForSelect('Duo')}
                    iconPos='left'
                  />
                </Col>
                <Col xs={4} md={4} className='d-flex justify-content-center'>
                  <Button
                    label={translations.service?.group || 'Group'}
                    className={`${styles_ed.bigButton} ${
                      selectedPriceFor === 'Group' ? styles_ed.selectedButton : ''
                    } ${styles_ed.bgindex1}`}
                    icon={<FontAwesomeIcon icon={faPeopleGroup} />}
                    onClick={() => handlePriceForSelect('Group')}
                    iconPos='left'
                  />
                </Col>
                <Col xs={4} md={4} className='d-flex justify-content-center'>
                  <Button
                    label={translations.service?.product || 'Product'}
                    className={`${styles_ed.bigButton} ${
                      selectedPriceFor === 'Product' ? styles_ed.selectedButton : ''
                    } ${styles_ed.bgindex1}`}
                    icon={<FontAwesomeIcon icon={faSpa} />}
                    onClick={() => handlePriceForSelect('Product')}
                    iconPos='left'
                  />
                </Col>
                <Col xs={4} md={4} className='d-flex justify-content-center'>
                  <Button
                    label={translations.service?.gift || 'Gift'}
                    className={`${styles_ed.bigButton} ${
                      selectedPriceFor === 'Gift' ? styles_ed.selectedButton : ''
                    } ${styles_ed.bgindex1}`}
                    icon={<FontAwesomeIcon icon={faGift} />}
                    onClick={() => handlePriceForSelect('Gift')}
                    iconPos='left'
                  />
                </Col>
                <Col xs={4} md={4} className='d-flex justify-content-center'>
                  <Button
                    label={translations.service?.vip || 'VIP'}
                    className={`${styles_ed.bigButton} ${
                      selectedPriceFor === 'VIP' ? styles_ed.selectedButton : ''
                    } ${styles_ed.bgindex1}`}
                    icon={<FontAwesomeIcon icon={faCrown} />}
                    onClick={() => handlePriceForSelect('VIP')}
                    iconPos='left'
                  />
                </Col>
              </Row>
              <Col className='mt-2' xs={12} md={12}>
                <Card className={styles_ed.cardHover}>
                  <p>
                    {translations.booking?.total || 'Total'} :{' '}
                    {cumulativePrice.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </p>
                </Card>
              </Col>
            </Col>
            <Col xs={6} md={6}>
              <Row>
                {selectOptions.map((option, index) => (
                  <Col className='mt-4' xs={4} md={4} key={index}>
                    <Button
                      className={`${styles_ed.selectButtonCustom} ${
                        selectedService === option.value
                          ? `${styles_ed.activeButton} ${styles_ed.selectedServiceButton}`
                          : ''
                      }`}
                      label={option.label}
                      onClick={() => handleSelectOptionChange({ value: option.value })}
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </Dialog>
    </>
  );
};

export default EventDialog;